import React from "react";
import { NameCell, Muted } from "../../components/tableCells/tableCells";
import gridSx from "../../styles/gridSx";
import { DataGrid } from "@mui/x-data-grid";

//scss import
import Styles from "./curators.module.scss";

// bootstrap import
import { Container, Row, Col } from "react-bootstrap";

// //svg import
import { ReactComponent as Add } from "../../resources/svg/Add.svg";
import { ReactComponent as Edit } from "../../resources/svg/Group 79.svg";
import { ReactComponent as Delete } from "../../resources/svg/Trash.svg";
import { ReactComponent as Deleteb } from "../../resources/svg/buetrash.svg";

// components import
import Cbtn from "../../components/commonbutton/cbtn";
import ResponsiveDrawer from "../../components/responsiveDrawer/responsiveDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import Deletefilemodal from "../../components/deletfilemodal/deletefilemodal";
import { useDispatch, useSelector } from "react-redux";
import { selectStatus } from "../../store/features/adminSlice";
import {
  getCurator,
  selectcuratorData,
  deleteCurator,
  selectCuratorError,
} from "../../store/features/curatorSlice";

import LoadingScreen from "../../components/loadingSpinner/loadingScreen";
// import AddCurator from "../../components/addCurator/addCurator";
// import EditCurator from "../../components/editCurator/editCurator";

const Curators = () => {
  const [curatorRow, setCuratorRow] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showSeq, setShowSeq] = React.useState(false);
  const [showEditSeq, setShowEditSeq] = React.useState([]);
  const [showDel, setShowDel] = React.useState(false);
  const [deleteIds, setDeleteIds] = React.useState([]);

  let navigate = useNavigate();
  let location = useLocation();
  let loadingStatus = useSelector(selectStatus);

  React.useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);

  React.useEffect(() => {
    if (loadingStatus === "error") {
      navigate("/login");
    }
  }, [loadingStatus]);

  let dispatch = useDispatch();
  let curDetails = useSelector(selectcuratorData);
  let curError = useSelector(selectCuratorError);

  let getData = async () => {
    let res = await dispatch(getCurator());
    setLoading(false);
    return res;
  };

  React.useEffect(() => {
    getData();
  }, []);

  React.useEffect(() => {
    if (curDetails) {
      setCuratorRow(() => {
        let temp = curDetails.map((ele, i) => ({
          id: ele._id,
          count: i + 1,
          name: ele.name,
          userId: ele.userId,
          editDelete: {
            details: ele,
            show: false,
            setShow: (value) => {
              setCuratorRow((prev) => {
                let temp = [...prev];
                temp[i].editDelete.show = value;
                return temp;
              });
            },
          },
        }));
        return temp;
      });
    }
  }, [curDetails]);

  const columns = [
    // Product Name----FIRST TITLE CELL---
    {
      field: "count",
      headerName: "SR",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 70,
      renderCell: (params) => <Muted>{params.value}</Muted>,
    },
    {
      field: "name",
      headerName: "Curators",
      description: "This column has a value getter and is not sortable.",
      sortable: true,
      flex: 3,
      // minWidth: 300,
      renderCell: (params) => <NameCell name={params.value} />,
    },
    {
      field: "userId",
      headerName: "ID",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 2,
      // minWidth: 300,
      renderCell: (params) => <Muted>{params.value}</Muted>,
    },

    {
      field: "editDelete",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 2,
      minWidth: 200,
      renderHeader: () => {
        return (
          <>
            <Cbtn
              className="huehuehue-white"
              type={"submit"}
              onClick={() => {
                if (deleteIds[0]) {
                  setShowDel(!showDel);
                } else {
                  alert("Select Curators");
                }
              }}
            >
              <Deleteb
                style={{
                  marginRight: "8px",
                  marginBottom: "5px",
                }}
              />
              Delete
            </Cbtn>
          </>
        );
      },
      renderCell: (params) => {
        return (
          <>
            <Edit
              onClick={() => {
                navigate(`/curator/${params.value.details._id}`);
              }}
              className={Styles.editSvg}
            />
            <Delete
              onClick={() => {
                setDeleteIds([params.value.details._id]);
                setShowDel(!showDel);
              }}
              className={Styles.deleteSvg}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      {loadingStatus === "Loading" && <LoadingScreen />}
      {loadingStatus === "fulfilled" && (
        <ResponsiveDrawer>
          <Container className={Styles.container}>
            <div className={Styles.toolbar}>
              <div>
                <h1 className={Styles.mainHeading}>Curators</h1>
                <div className={Styles.subHeading}>
                  {curatorRow?.length
                    ? `${curatorRow.length} ${
                        curatorRow.length === 1 ? "curator" : "curators"
                      } can run the live auction`
                    : "Curators run the auction from the curator portal"}
                </div>
              </div>
              <div className={Styles.actions}>
                <Cbtn
                  className="huehuehue"
                  type={"button"}
                  to="/curator/new"
                  style={{ backgroundColor: "#0040A8" }}
                >
                  <Add className={Styles.add} />
                  New Curator
                </Cbtn>
              </div>
            </div>

            {/* ------------------TABLE START----------- */}

            <Row className={`${Styles.table} ${Styles.gridWrap}`}>
              <DataGrid
                autoWidth
                autoHeight
                rowHeight={60}
                disableSelectionOnClick
                disableColumnFilter
                disableColumnMenu
                headerHeight={80}
                onSelectionModelChange={(ids) => {
                  setDeleteIds(ids);
                }}
                pageSize={10}
                rowsPerPageOptions={[10]}
                sx={gridSx}
                loading={loading && !curError}
                rows={curatorRow}
                columns={columns}
                checkboxSelection
              />
            </Row>
          </Container>
          <Deletefilemodal
            ids={deleteIds}
            show={showDel}
            deleteFn={deleteCurator}
            setShow={setShowDel}
          />

          {/* </Row> */}
          {/* -------------------TABLE END------------------ */}
        </ResponsiveDrawer>
      )}
    </>
  );
};

export default Curators;
